import { trimInvalidUTCDate } from "helpers/api/utils";

// helper
export const getNotificationMessage = (
  notificationObject,
  returnJSX = true
) => {
  if (!notificationObject) return returnJSX ? <></> : "";
  const isRead = notificationObject.isRead;
  const eventType = notificationObject.eventType;
  const licenseId = notificationObject.licenseId;
  const licenseNumber = notificationObject.licenseNumber ?? "";
  const licenseLabel = licenseNumber.trim() ? `License ${licenseNumber}` : "License";
  const licenseContext = [
    notificationObject.stateCode,
    notificationObject.commodity,
  ]
    .filter(value => typeof value === "string" && value.trim() !== "")
    .join(" · ");
  const licenseDescription = licenseContext
    ? `${licenseLabel} (${licenseContext})`
    : licenseLabel;
  const companyId = notificationObject.companyId;
  const legalName =
    notificationObject.legalName ?? "a company you are following";
  const licenseRegisteredDate = trimInvalidUTCDate(
    notificationObject.licenseRegisteredDate
  );
  const licenseExpiryDate = trimInvalidUTCDate(
    notificationObject.licenseExpiryDate
  );
  const createdOn = trimInvalidUTCDate(notificationObject.createdOn);

  let description;

  const companyLinkTag =
    companyId && companyId?.replace(/[-0]/g, "")?.length > 0 ? (
      <a href={`/companies/${companyId}`}>{legalName}</a>
    ) : null;
  const companyText =
    companyLinkTag && legalName && returnJSX ? (
      <>for {companyLinkTag}</>
    ) : (
      `for ${legalName}`
    );

  if (eventType === "New") {
    description = returnJSX ? (
      <>
        New {licenseDescription} has been registered {companyText} on{" "}
        {createdOn}
      </>
    ) : (
      `New ${licenseDescription} has been registered ${companyText} on ${createdOn}`
    );
  } else if (eventType === "Renewal") {
    description = returnJSX ? (
      <>
        {licenseDescription} {companyText} has been renewed on {createdOn}
      </>
    ) : (
      `${licenseDescription} ${companyText} has been renewed on ${createdOn}`
    );
  } else if (eventType === "Expiry") {
    description = returnJSX ? (
      <>
        {licenseDescription} {companyText} expires on{" "}
        {licenseExpiryDate}
      </>
    ) : (
      `${licenseDescription} ${companyText} expires on ${licenseExpiryDate}`
    );
  } else if (eventType === "esiidExport" || eventType === "eclExport") {
    const message = notificationObject.message || "";
    const lowerMessage = message.toLowerCase();
    const fileUrl = notificationObject.fileurl;

    if (lowerMessage.includes("started")) {
      description = message;
    } else if (lowerMessage.includes("completed")) {
      if (returnJSX && fileUrl) {
        description = (
          <>
            {message }{'.'} Click{" "}
            <a href={fileUrl} target="_blank" rel="noreferrer">
              here
            </a>
            {" to download."}
          </>
        );
      } else {
        const downloadSuffix = fileUrl
          ? ` Download the data from this url ${fileUrl}`
          : "";
        description = `${message}${downloadSuffix}`;
      }
    } else {
      description = message;
    }
  }

  return isRead == 0 && returnJSX ? (
    <strong>{description}</strong>
  ) : (
    description
  );
};
